import { isHanabitechUser } from 'src/constants/utils';

export const shouldShowChatWithHanaModule = (
  email: string | null | undefined,
): boolean => {
  if (!email) {
    return false;
  }

  const normalizedEmail = email.trim().toLowerCase();

  if (normalizedEmail.length === 0) {
    return false;
  }

  return isHanabitechUser(normalizedEmail);
};
